type Reporter = { addError: (error: Error) => void };

const MAX_PENDING = 10;

let reporter: Reporter | undefined;
let pending: Error[] = [];
let disabled = false;

export const setReporter = (next: Reporter): void => {
  reporter = next;
  const queued = pending;
  pending = [];
  queued.forEach((error) => {
    try {
      next.addError(error);
    } catch {
      return;
    }
  });
};

export const disableReporter = (): void => {
  disabled = true;
  pending = [];
};

export const reportError = (error: Error): void => {
  if (!reporter) {
    if (!disabled && pending.length < MAX_PENDING) pending.push(error);
    return;
  }
  reporter.addError(error);
};
